import api from "../../../helpers/api";

// export const getPrivateInquiries = (body) =>
//   api.post("moderation-pool/get-pending-suppliers-public-inquiry", { ...body });


export const getAllPendingProposal = (body) => api.post(`public-supplier-staging-proposals/search`, {...body})
export const getSinglePendingProposal = (id) => api.get(`/public-supplier-staging-proposals/${id}`)
export const moderatePendingProposal = (body) => api.post(`/public-supplier-staging-proposals/moderate`, {...body})
export const rejectPendingProposal = (id) => api.put(`/public-supplier-staging-proposals/reject/${id}`)